import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  Button,
  Chip,
  Stack,
  useTheme,
} from "@mui/material";
import ShieldOutlinedIcon from "@mui/icons-material/ShieldOutlined";
import SecurityOutlinedIcon from "@mui/icons-material/SecurityOutlined";
import VerifiedOutlinedIcon from "@mui/icons-material/VerifiedOutlined";
import PhoneOutlinedIcon from "@mui/icons-material/PhoneOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";
import DashboardHeader from "../Dashboard/DashboardHeader";
import { useNavigate } from "react-router-dom";

export default function ContactSupport() {
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";

  const bg = isDark ? "#0B1220" : "#f5f7fb";
  const cardBg = isDark ? "#121C2D" : "#ffffff";
  const border = isDark
    ? "1px solid rgba(255,255,255,0.08)"
    : "1px solid rgba(0,0,0,0.08)";

  const navigate = useNavigate();
  const navigateback = () => {
    navigate("/profile-settings");
  };

  return (
    <>
      <DashboardHeader />
      <Box sx={{ bgcolor: bg, minHeight: "100vh", px: 7, py: 2 }}>
        {/* HEADER */}
        <Box display={"flex"} justifyContent={"space-between"}>
          <Box>
            <Typography variant="h5" fontWeight={700}>
              Contact Support
            </Typography>
            <Typography fontSize={13} color="text.secondary" mb={3}>
              Help & Compliance Center
            </Typography>
          </Box>
          <Box>
            <Button onClick={navigateback}>Back</Button>
          </Box>
        </Box>

        {/* COMPLIANCE CARD */}
        <Card
          sx={{
            bgcolor: cardBg,
            borderRadius: 4,
            border,
            mb: 4,
            p: { xs: 2, md: 3 },
          }}
        >
          <Grid container spacing={3} alignItems="center">
            <Grid size={{ xs: 12, md: 7 }} item xs={12} md={7}>
              <Chip
                label="RBI AUTHORIZED PSO"
                color="primary"
                size="small"
                sx={{ mb: 2 }}
              />

              <Typography variant="h5" fontWeight={700} gutterBottom>
                About Our Compliance &{" "}
                <span style={{ color: "#3b82f6" }}>Certifications</span>
              </Typography>

              <Typography fontSize={14} color="text.secondary" mb={2}>
                <b>Transaction Analysts (India) Pvt. Ltd.</b> is a fully
                authorized Payment System Operator (PSO), regulated by the{" "}
                <b>Reserve Bank of India (RBI)</b>.
              </Typography>

              <Typography fontSize={14} color="text.secondary">
                We maintain the highest standards of financial security,
                strictly adhering to KYC, AML, and CFT guidelines to provide a
                safe and transparent digital wallet experience.
              </Typography>
            </Grid>

            <Grid size={{ xs: 12, md: 5 }} item xs={12} md={5}>
              <Stack direction="row" spacing={2} justifyContent="center">
                {[
                  { icon: <ShieldOutlinedIcon />, label: "Data Security" },
                  { icon: <SecurityOutlinedIcon />, label: "Infosec" },
                  { icon: <VerifiedOutlinedIcon />, label: "Quality" },
                ].map((item) => (
                  <Card
                    key={item.label}
                    sx={{
                      width: 120,
                      textAlign: "center",
                      bgcolor: isDark ? "#0E2239" : "#f9fafb",
                      borderRadius: 3,
                      border,
                      p: 2,
                    }}
                  >
                    <Box sx={{ color: "#22c55e", mb: 1 }}>{item.icon}</Box>
                    <Typography fontSize={12} fontWeight={600}>
                      {item.label}
                    </Typography>
                  </Card>
                ))}
              </Stack>
            </Grid>
          </Grid>
        </Card>

        {/* GRIEVANCE REDRESSAL */}
        <Typography align="center" fontWeight={700} letterSpacing={2} mb={3}>
          GRIEVANCE REDRESSAL
        </Typography>

        <Grid container spacing={3} mb={4}>
          {[
            {
              name: "TAWallet Support",
              role: "Support System",
              phone: "+91-9916788345",
              email: "support@taipl.in",
            },
            {
              name: "TAWallet Support",
              role: "Fraud Compilance",
              phone: "+91-9803980306",
              email: "reportfraud@taipl.in",
            },
          ].map((p) => (
            <Grid size={{ xs: 12, md: 6 }} item xs={12} md={6} key={p.name}>
              <Card sx={{ bgcolor: cardBg, borderRadius: 4, border, p: 3 }}>
                <Typography fontWeight={700}>{p.name}</Typography>
                <Typography fontSize={13} color="primary" mb={2}>
                  {p.role}
                </Typography>

                <Stack spacing={1.5}>
                  <Stack direction="row" spacing={1} alignItems="center">
                    <PhoneOutlinedIcon fontSize="small" />
                    <Typography
                      sx={{
                        fontSize: 14,
                        color: "blue",
                        textDecoration: "none",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      {p.phone}
                    </Typography>
                  </Stack>

                  <Stack direction="row" spacing={1} alignItems="center">
                    <EmailOutlinedIcon fontSize="small" />
                    <Typography
                      component="a"
                      href={`mailto:${p.email}`}
                      sx={{
                        fontSize: 14,
                        color: "blue",
                        textDecoration: "none",
                        "&:hover": { textDecoration: "underline" },
                      }}
                    >
                      {p.email}
                    </Typography>
                  </Stack>
                </Stack>
              </Card>
            </Grid>
          ))}
        </Grid>

        {/* CUSTOMER SUPPORT */}
        <Grid container spacing={3}>
          {/* <Grid size={{xs:12, md:6}} item xs={12} md={6}>
          <Card sx={{ bgcolor: cardBg, borderRadius: 4, border, p: 3 }}>
            <Typography fontWeight={700} mb={2}>
              Customer Support
            </Typography>

            <Stack spacing={2}>
              <Stack direction="row" spacing={1}>
                <PhoneOutlinedIcon />
                <Typography>+91-80-26784479</Typography>
              </Stack>

              <Stack direction="row" spacing={1}>
                <PhoneOutlinedIcon />
                <Typography>+91-9916788345 (WhatsApp)</Typography>
              </Stack>

              <Stack direction="row" spacing={1}>
                <EmailOutlinedIcon />
                <Typography>support@transactionanalysts.com</Typography>
              </Stack>

              <Button
                variant="contained"
                sx={{
                  mt: 2,
                  textTransform: "none",
                  borderRadius: 2,
                }}
              >
                Raise a Ticket
              </Button>
            </Stack>
          </Card>
        </Grid> */}

          <Grid size={{ xs: 12, md: 12 }} item xs={12} md={6}>
            <Card sx={{ bgcolor: cardBg, borderRadius: 4, border, p: 3 }}>
              <Typography fontWeight={700} mb={2}>
                Headquarters
              </Typography>

              <Stack direction="row" spacing={1} mb={2}>
                <LocationOnOutlinedIcon />
                <Typography>Bengaluru, Karnataka, India</Typography>
              </Stack>

              <Box
                sx={{
                  height: 180,
                  borderRadius: 3,
                  overflow: "hidden",
                  border,
                }}
              >
                <iframe
                  title="map"
                  width="100%"
                  height="100%"
                  frameBorder="0"
                  src="https://maps.google.com/maps?q=Bangalore&t=&z=13&ie=UTF8&iwloc=&output=embed"
                />
              </Box>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </>
  );
}
